export default {
  nav: 'Booth reservation/Get floorplan',
  step1: 'Select service type',
  step2: 'Confirm company information',
  step3: 'Submit service order',
  step4: 'Customer follow-up docking',
  fairTime: 'Fair time',
  form: {
    input: 'Please enter (required)',
    scale: 'Please select the booth area (required)',
    submit: 'Submit'
  },
  tip: {
    title: 'Booth application instructions',
    n1: 'After the booth consultation is submitted, the staff will contact you one-on-one according to the reserved contact information within 1-2 working days',
    n1_1: 'After the booth application is submitted, the staff will contact you one-on-one within 1-2 working days according to the reserved contact information展位申请提交后，工作人员将在1 - 2个工作日内根据预留的联系方式与您进行一对一对接',
    n2: 'Submit the business license of the company',
    n3: 'Submit product picture and name',
    n4: 'Receive exhibition presentation documents and booth drawings',
    n5: 'Submit booth application form/Sign booth contract',
    n6: 'Pay the contract booth deposit',
    t1: 'Communication needs ',
    i1: 'Exhibitors reserve contact information, and the project leader will follow up and communicate the booth needs of exhibitors; ',
    t2: 'Submit for review ',
    i2: "After the exhibitors confirm the intention to participate with the project leader, submit the company name, product name and introduction, the company's official website, contact person, contact information, etc., waiting for the qualification review of the host; ",
    t3: 'Booth Offer ',
    i3: 'The project leader shall provide the exhibition invitation letter and the specific booth price to the exhibitors; ',
    t4: 'Booth map ',
    i4_1: '1. The exhibition has been mapped, and the optional booth map is provided for the exhibitors to choose;',
    i4_2: '2. If the exhibition is not mapped out, the booth deposit should be paid 2-3 months in advance to wait for the location allocation;',
    i4_3: '3. Tight exhibition, need to queue up at least 6 months in advance to wait for the location allocation; ',
    t5: 'Contract Signing ',
    i5: 'The exhibitor and the organizer sign the booth contract, stamped in two copies and effective, according to the contract payment; ',
    t6: 'Booth Related Services ',
    i6: 'After the booth is confirmed, the exhibitors will collect the information form, exhibitor card, exhibition equipment rental, car license and other materials according to the schedule; ',
    t7: 'Invoice ',
    i7: 'Issue the official invoice 7 working days after the end of the exhibition; ',
    t8: 'Comments and Comments ',
    i8: 'Collect the evaluation and feedback of exhibitors on the exhibition after the exhibition, and improve the service; '
  }
}
